import React from 'react';
import { graphql, navigate } from 'gatsby';
import SEO from '@components/SEO';
import Hero from '@components/Hero';
import { Col, Divider, Grid, Row } from '@components/Grid';
import Layout from '@components/Layout';
import styles from '../stay/styles.module.scss';
import Card from '@components/Card';
import CallToActions from '@components/CallToActions';

const Seasons = ({
    data: {
        page: {
            frontmatter: { title, description, image, seoTitle, seoDescription, callToActions },
        },
        seasons: { edges: seasons },
    },
}) => {
    return (
        <Layout>
            <SEO
                title={seoTitle || 'Seasons | Retreat East | Ipswich Hotel & Restaurant'}
                description={
                    seoDescription ||
                    description ||
                    'Discover seasonal experiences at Retreat East throughout the year.'
                }
            />
            <Hero image={image} imageFullWidth imageStyle={{ objectPosition: '50% 100%' }}>
                <h1>{title}</h1>
                {!!description && <p>{description}</p>}
            </Hero>

            <Grid>
                <Row>
                    {seasons.map(
                        (
                            {
                                node: {
                                    frontmatter: { path, title, description, image },
                                },
                            },
                            index
                        ) => (
                            <Col xs={12} md={6} key={title}>
                                <div className={styles.package}>
                                    <Card
                                        className={styles.packageCard}
                                        onClick={() => navigate(path)}
                                    >
                                        {image?.childImageSharp?.fluid && (
                                            <Card.Image
                                                height={280}
                                                fluid={image.childImageSharp.fluid}
                                                alt={`Season image ${index + 1}`}
                                            />
                                        )}
                                        <Card.Title multiLine>{title}</Card.Title>
                                        <Card.Content>
                                            <p>{description}</p>
                                        </Card.Content>
                                    </Card>
                                </div>
                            </Col>
                        )
                    )}
                </Row>
            </Grid>

            <Divider />

            {callToActions && (
                <CallToActions>
                    {callToActions.map(callToAction => (
                        <CallToActions.CallToAction key={callToAction.title} {...callToAction} />
                    ))}
                </CallToActions>
            )}
        </Layout>
    );
};

export default Seasons;

export const query = graphql`
    query($path: String!) {
        page: markdownRemark(frontmatter: { path: { eq: $path } }) {
            frontmatter {
                title: seasons_title
                description: seasons_description
                seoTitle: seasons_seo_title
                seoDescription: seasons_seo_description
                image: seasons_image {
                    childImageSharp {
                        fluid(maxWidth: 1920) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                callToActions: seasons_call_to_actions {
                    title: seasons_call_to_actions_title
                    description: seasons_call_to_actions_description
                    buttonText: seasons_call_to_actions_button_text
                    buttonLink: seasons_call_to_actions_button_link
                    image: seasons_call_to_actions_image {
                        childImageSharp {
                            fluid(maxWidth: 1200) {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                }
            }
        }
        seasons: allMarkdownRemark(
            sort: { fields: [frontmatter___season_order], order: ASC }
            filter: { fileAbsolutePath: { regex: "/data/seasons/(?!.md$)/" } }
        ) {
            edges {
                node {
                    frontmatter {
                        path
                        title: season_title
                        description: season_card_description
                        image: season_image {
                            childImageSharp {
                                fluid(maxWidth: 560) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
